module.exports = __webpack_public_path__ + "static/media/fotogalereya8.a2ddb17a.jpg";